import { store } from '@/store';
const log = {
    clarityLog(tagName, tagValue){
        axios.post(apiUrl.ClarityLog, {
            tagName: tagName,
            tagValue: tagValue,
            fpc: store.state.estimate.uid,
            clarityId: store.state.estimate.ClarityId,
            insuranceType: store.state.insCategory === 'Car' ? '汽車險' : '機車險'
        }).catch(err=>{});
    },
};
export default log;